import { Injectable } from '@angular/core';
import { HttpService } from '../../core/services/http/http.service';
import { ParmedApiService as ParmedApi } from '../../core/api/parmed-api.service';

@Injectable()
export class ContactUsService {
  constructor(private http: HttpService, private api: ParmedApi) {}

  PostContactUs(contactUsData: any) {
    return this.http.post(this.api.Config.CONTACT_US_URL, contactUsData);
  }
}
